<div>
    <app-button
            (click)="resend()"
            [label]="'forgot_password.check_email_button_label' | translate"
            [size]="isMobile ? ButtonSize.LARGE : ButtonSize.LARGER"
            [state]=" !isButtonDisabled? ButtonState.REGULAR : ButtonState.DISABLED"
            [type]="ButtonType.PRIMARY"
    ></app-button>
</div>
